<template>
  <div class="modal_container">
    <div class="modal">
      <div class="modal-content">
        <div class="caption">
          <div class="title">{{textContent.titleAdd}}</div>
          <div @click="modalClose" class="close"></div>
        </div>
        <div class="modal-scroll">
          <form v-on:submit.prevent="addItem">
            <form-input name="title"></form-input>
            <p class="subheading">Добавьте изображения</p>
            <form-image-album v-for="(image, index) of counterImages" :index="index"></form-image-album>
            <div class="buttons-control">
              <span class="remove" :class="{active: counterImages > 1}" @click="removeImage">Удалить</span>
              <span class="add" @click="counterImages++">Добавить</span>
            </div>
          </form>
          <div class="buttons">
            <div class="next">
              <button @click="modalClose" class="cancel">{{textContent.cancelButton}}</button>
              <button class="confirm" @click="addItem">{{textContent.submitButton}} &#8594;</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import FormInput from '@/components/create-form/Input'
  import {createNamespacedHelpers} from 'vuex'
  import FormTextArea from '@/components/create-form/TextArea'
  import FormFile from '@/components/create-form/File'
  import Tabs from '@/components/create-form/Tabs'
  import FormImageAlbum from "../../create-form/ImageAlbum";

  const {mapMutations, mapGetters, mapActions, mapState} = createNamespacedHelpers('mainPage')

  export default {
    data() {
      return {
        counterImages: 1
      }
    },
    computed: {
      ...mapState([
        'textContent'
      ]),
      ...mapGetters([
        'isLastTab'
      ])
    },
    methods: {
      ...mapActions([
        'modalClose',
        'addItem',
        'initFields',
        'onNext',
        'onPrev'
      ]),
      ...mapMutations([
        'setTabs',
        'setCurrentTabId'
      ]),
      removeImage() {
        if (this.counterImages > 1) {
          this.counterImages--
        }
      }
    },
    created() {
      this.setCurrentTabId(0);
      this.initFields({
        title: {
          value: '',
          parameterName: 'title',
          name: 'Имя альбома',
          errorId: null,
          errors: {empty: 'Введите имя альбома'},
          tabId: 0
        },
      })
    },
    components: {
      FormImageAlbum,
      FormInput,
      FormTextArea,
      FormFile,
      Tabs
    }
  }
</script>

<style lang="scss" scoped>
  .buttons-control {
    display: flex;
  }
  span {
    &.add, &.remove {
      display: block;
      background: #089cd3;
      border: 1px solid #089cd3;
      color: #fff;
      width: max-content;
      border-radius: 30px;
      padding: 10px 34px;
      transition: 0.3s;
      margin-bottom: 20px;
    }
    &.remove {
      background-color: transparent;
      color: #089cd3;
      opacity: 0.3;
      margin-right: 6px;
      &:hover {
        cursor: default;
      }
      &.active {
        opacity: 1;
        &:hover {
          color: white;
          background-color: #089cd3;
          cursor: pointer;
          transition: 0.3s;
        }
      }
    }
    &.add {
      &:hover {
        color: #089cd3;
        background-color: transparent;
        cursor: pointer;
        transition: 0.3s;
      }
    }
  }
  .subheading {
    margin-bottom: 20px !important;
    color: #6e7074;
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/albums/CreateModal.vue